@if (weather$ | async; as weather) {
  @if (weather) {
    <div class="weather">
      @if (weather.currentWeather) {
        <p class="weather__current_title bold">{{ 'land.weather.actual-forecast' | i18next }}</p>
        <div class="weather__current">
          <div>
            <small class="medium">
              {{ 'land.weather.wind' | i18next }}: {{ weather.currentWeather.wind.speed }}
              {{ 'land.weather.ms' | i18next }}
            </small>
            <p class="semibold">
              {{ weather.currentWeather.main.temp | round }}
              <span>&deg;C</span>
            </p>
            <small class="medium">
              {{ 'land.weather.feel' | i18next }}: {{ weather.currentWeather.main.feels_like | round }}&deg;C
            </small>
          </div>
          <figure>
            <img
              loading="lazy"
              width="160"
              height="160"
              [src]="'https://media.sharry.land/app/images/weather/' + weather.currentWeather.weather[0].icon + '.webp'"
              [alt]="weather.currentWeather.weather[0].main" />
            <figcaption>{{ weather.currentWeather.weather[0].id | description | i18next }}</figcaption>
          </figure>
        </div>
      } @else {
        <p class="bigger">
          {{ 'land.weather.error' | i18next }}
        </p>
      }
      @for (day of weather.list; track day; let i = $index) {
        <section>
          <p class="bold">{{ i | weekDay | i18next }}</p>
          <div class="weather__days">
            @for (h of day; track h) {
              <div class="weather__days__day">
                <p class="bigger semibold">{{ h.dt_txt | hour }}</p>
                <img
                  height="80"
                  width="80"
                  [src]="'https://media.sharry.land/app/images/weather/' + h.weather[0].icon + '.webp'"
                  [alt]="h.weather[0].main" />
                <p class="bigger semibold">{{ (h.main.temp_min + h.main.temp_max) / 2 | round }}&deg;C</p>
                <small>{{ h.weather[0].id | description | i18next }}</small>
              </div>
            }
          </div>
        </section>
      }
    </div>
  }
} @else {
  <sharry-loading></sharry-loading>
}
